{
	"invalidListItem": "The value inserted is not a valid option.",
	"invalidListTitle": "Invalid value",
	"selectAValidOption": "Please select a valid option.",
	"selectAValue": "Select a value",
	"invalidValue": "The value inserted is not valid.",
	"values": {
		"boolean": {
			"true": "Yes",
			"false": "No"
		}
	}
}
